// vars

import type { CollectionKey } from "astro:content";
import type { IconKey } from "./modules/Icons/packIcons";

export const env = {
  mode: import.meta.env.MODE,
  isDev: import.meta.env.DEV,
  isStaging: import.meta.env.VERCEL_GIT_COMMIT_REF === 'staging',
  isProd: import.meta.env.PROD,
  isSSR: import.meta.env.SSR,
} as const;

export const cloudinaryCfg = {
  name: 'mikestopcontinues',
  key: '664812751292626',
};
export const cloudinarySecret = import.meta.env.CLOUDINARY_SECRET;

export const turnstileSiteKey = import.meta.env.TURNSTILE_SITE_KEY;
export const turnstileSecretKey = import.meta.env.TURNSTILE_SECRET_KEY;

export const cmsProxyUrl = 'http://localhost:5051/api/v1';

export const site = {
  url: import.meta.env.SITE,
  title: 'Mike Stop Continues',
  shortTitle: 'MSC',
  sep: '-',
} as const;

export const feed = {
  title: 'New Articles & Projects',
  collections: [
    'articles', 
    'books', 
    'projects',
  ] satisfies CollectionKey[],
  limit: 33,
} as const;

export const author = {
  name: 'Mike Stop Continues',
  url: site.url,
  // image: '???',
  // blurb: '???',
  // jobTitle: 'Founder, Engineer, and Author',
  // worksFor: 'BrowserCat',
} as const;

export const logo = {
  url: 'https://www.mikestopcontinues.com/logo/logo.png',
  width: 840,
  height: 840,
  alt: 'Mike Stop Continues, further and further and further...',
} as const;

export const socialMedia = {
  twitterHandle: '@stopcontinues',
  facebookAppId: '211661538844751',
} as const;

export const socialMediaUrls = {
  // facebookProfile: 'https://www.facebook.com/mikestopcontinues',
  amazon: 'https://www.amazon.com/Mike-Stop-Continues/e/B01KJ70B7U',
  bookbub: 'https://www.bookbub.com/authors/mike-stop-continues',
  facebook: 'https://www.facebook.com/stopcontinues',
  github: 'https://github.com/mikestopcontinues',
  goodreads: 'https://www.goodreads.com/author/show/15643705.Mike_Stop_Continues',
  instagram: 'https://www.instagram.com/mikestopcontinues/',
  linkedin: 'https://www.linkedin.com/in/mikestopcontinues',
  pinterest: 'https://www.pinterest.com/stopcontinues/',
  twitter: 'https://twitter.com/stopcontinues',
  youtube: 'https://www.youtube.com/channel/UCHNfHdiImSnOjfwW5dvgU0Q',
  email: '/contact',
} as const satisfies Partial<Record<IconKey, string>>;

export const socialLinks = [
  {text: '', link: '',}
];

export const blog = {pageSize: 10} as const;

export const headerlinks = [
  {text: 'Articles', link: '/articles'},
  {text: 'Projects', link: '/projects'},
  {text: 'Books', link: '/projects#books'},
  {text: 'Contact', link: '/contact'},
] as const;

export const footerLinks = [
  {text: 'Articles', link: '/articles'},
  {text: 'Projects', link: '/projects'},
  {text: 'Books', link: '/projects#books'},
  {text: 'Resume', link: 'https://standardresume.co/r/mikestopcontinues'},
  {text: 'Contact', link: '/contact'},
] as const;
